import {
  Component,
  OnInit,
  Output,
  EventEmitter,
  Inject,
  ViewChild
} from '@angular/core';

import { DropdownSingleComponent } from './components/dropdown-single.component';

import { SharedModule } from './shared.module';

import { UtilsService } from './utils.service';
import { SettingsValuesService } from './settings.values.service';
import { app_ShellService } from './app.shell.service';
import { app_OperationService } from './app.operation.service';
import { app_DatasourceService } from './app.datasource.index';
import { app_FlowService } from './app.flow.index';
import { app_FrontendFlowService } from './app.frontend.flow.service';
import { app_ReportService } from './app.report.index';
import { app_LocalizationService } from './app.localization.service';
import { app_home_ComponentContextService } from './app.home.component.context.service';
import { Language } from './localization.service';
import { JobStatus, EAssignmentMode } from './common-interfaces'
import { ApplicationType, ComponentType } from './app-context.service';
import { $frontendTypes} from './app.frontend.types'
import { $frontendTypes as $types} from './app.frontend.types' 

import { EModalSize, EToasterType, EToasterPosition } from 'wavelength-ui';
@Component({
  imports: [
    SharedModule,
  ],
  selector: 'app-home',
  templateUrl: './app.home.component.html'
})
export class app_homeComponent implements OnInit {

  //#region Outputs
  @Output()
  $finish = new EventEmitter();
  //#endregion

  //#region title
  // Make it async so that it won't cause expressionChangedAfterItHasBeenCheckedError
  // The title is often meant to be shown from the parent (shell breadcrumb for example)
  // and often it will cause an expressionChangedAfterItHasBeenCheckedError because 
  // the parent has already been checked and the child now change something on the parent 
  // in dev, CD is run twice
  $titleChange = new EventEmitter<string>(true);
  private $_title: string;
  get title(): string {
    return this.$_title;
  }
  set title(t: string) {
    this.$_title = t;
    this.$titleChange.emit(this.$_title);
  }
  //#endregion title
  toolbar = {
  };


  fieldsets = {
  };

  @ViewChild('dd_config') dd_config: DropdownSingleComponent;
  @ViewChild('dd_method') dd_method: DropdownSingleComponent;

  constructor(
    private $utils: UtilsService,
private $settings: SettingsValuesService,
private $shell: app_ShellService,
private $datasources: app_DatasourceService,
private $flows: app_FlowService,
private $frontendFlows: app_FrontendFlowService,
private $reports: app_ReportService,
private $localization: app_LocalizationService,
private $operations: app_OperationService,
private $context: app_home_ComponentContextService,
) { 

  }

  ngOnInit(): void {
    this.$init();
  
  }

  initialized = false;

  async $init() {
    this.title = 'Home';
    this.initialized = true;
  }

  close() {
    this.$finish.emit();
  }

  typeValue = null;
  typeList = [
    {
      key: 6,
      name: 'Datasource'
    },
    {
      key: 9,
      name: 'Function'
    }
  ];

  async typeDisplayWithFn(value: any): Promise<string> {
    return this.typeList.find(item => item.key === value)?.name;
  }

  async typeOptionsFn(filterText: string): Promise<{ list: Array<{ key: any; name: string; disabled?: boolean; }>, totalCount?: number, top?: number }> {
    if (this.$utils.isDefinedTrimmed(filterText)) {
      return { list: this.typeList.filter(item => item.name.startsWith(filterText)), totalCount: this.typeList.length };
    } else {
      return { list: this.typeList, totalCount: this.typeList.length };
    }
  }

  typeValueChange(value) {
    this.typeValue = value;
    this.configValueChange(null);
    this.dd_config.clearListData();
  }


  configValue = null;
  config = null;
  configList = [
    {
      key: 'app/functions/edi_export_completed_shipments',
      name: 'app/functions/edi_export_completed_shipments',
      referenceName: 'edi_export_completed_shipments',
      appReferenceName: 'app',
      type: 9,
        inParams: [
          {
            required: false,
            id: 'project_lookups',
            type: 'string',
            isCollection: true
          },
          {
            required: false,
            id: 'project_ids',
            type: 'number',
            isCollection: true
          },
          {
            required: false,
            id: 'days',
            type: 'number',
            isCollection: false
          },
          {
            required: false,
            id: 'shipment_type',
            type: 'number',
            isCollection: false
          },
          {
            required: false,
            id: 'transaction_type',
            type: 'string',
            isCollection: false
          },
          {
            required: false,
            id: 'has_order_transmissions',
            type: 'boolean',
            isCollection: false
          },
          {
            required: false,
            id: 'in_transmission_type',
            type: 'string',
            isCollection: false
          },
          {
            required: false,
            id: 'out_transmission_type',
            type: 'string',
            isCollection: false
          },
          {
            required: false,
            id: 'integration_id',
            type: 'string',
            isCollection: false
          },
        ]
    },
    {
      key: 'app/functions/edi_export_inventory_snapshot',
      name: 'app/functions/edi_export_inventory_snapshot',
      referenceName: 'edi_export_inventory_snapshot',
      appReferenceName: 'app',
      type: 9,
        inParams: [
          {
            required: false,
            id: 'owner_lookup',
            type: 'string',
            isCollection: false
          },
          {
            required: true,
            id: 'project_lookup',
            type: 'string',
            isCollection: false
          },
          {
            required: true,
            id: 'integration_id',
            type: 'string',
            isCollection: false
          },
          {
            required: true,
            id: 'transaction_type',
            type: 'string',
            isCollection: false
          },
          {
            required: false,
            id: 'transaction_id',
            type: 'string',
            isCollection: false
          },
          {
            required: false,
            id: 'render_options',
            type: 'object',
            isCollection: false
          },
        ]
    },
    {
      key: 'app/functions/edi_set_wavelength_connector_transmission',
      name: 'app/functions/edi_set_wavelength_connector_transmission',
      referenceName: 'edi_set_wavelength_connector_transmission',
      appReferenceName: 'app',
      type: 9,
        inParams: [
          {
            required: false,
            id: 'shipment_id',
            type: 'number',
            isCollection: false
          },
          {
            required: true,
            id: 'integration_id',
            type: 'string',
            isCollection: false
          },
          {
            required: true,
            id: 'transaction_id',
            type: 'string',
            isCollection: false
          },
          {
            required: false,
            id: 'transaction_type',
            type: 'string',
            isCollection: false
          },
          {
            required: true,
            id: 'file_content',
            type: 'string',
            isCollection: false
          },
        ]
    },
    {
      key: 'app/functions/edi_sftp_pull_and_submit',
      name: 'app/functions/edi_sftp_pull_and_submit',
      referenceName: 'edi_sftp_pull_and_submit',
      appReferenceName: 'app',
      type: 9,
        inParams: [
          {
            required: true,
            id: 'integration_id',
            type: 'string',
            isCollection: false
          },
          {
            required: true,
            id: 'sftp_connection',
            type: 'string',
            isCollection: false
          },
          {
            required: true,
            id: 'sftp_path',
            type: 'string',
            isCollection: false
          },
          {
            required: false,
            id: 'sftp_extension',
            type: 'string',
            isCollection: false
          },
        ]
    },
    {
      key: 'app/functions/edi_sftp_push',
      name: 'app/functions/edi_sftp_push',
      referenceName: 'edi_sftp_push',
      appReferenceName: 'app',
      type: 9,
        inParams: [
          {
            required: true,
            id: 'integration_id',
            type: 'string',
            isCollection: false
          },
          {
            required: true,
            id: 'file_content',
            type: 'string',
            isCollection: false
          },
          {
            required: false,
            id: 'transaction_type',
            type: 'string',
            isCollection: false
          },
        ]
    },
    {
      key: 'app/functions/edi_submit_entity_import_xml_request',
      name: 'app/functions/edi_submit_entity_import_xml_request',
      referenceName: 'edi_submit_entity_import_xml_request',
      appReferenceName: 'app',
      type: 9,
        inParams: [
          {
            required: false,
            id: 'integration_id',
            type: 'string',
            isCollection: false
          },
          {
            required: false,
            id: 'entity_import_content',
            type: 'string',
            isCollection: false
          },
        ]
    },
    {
      key: 'app/functions/edi_x12_940_map',
      name: 'app/functions/edi_x12_940_map',
      referenceName: 'edi_x12_940_map',
      appReferenceName: 'app',
      type: 9,
        inParams: [
          {
            required: false,
            id: 'integration_id',
            type: 'string',
            isCollection: false
          },
          {
            required: false,
            id: 'transaction_id',
            type: 'string',
            isCollection: false
          },
          {
            required: false,
            id: 'correlation_id',
            type: 'string',
            isCollection: false
          },
          {
            required: false,
            id: 'transaction_type',
            type: 'string',
            isCollection: false
          },
          {
            required: false,
            id: 'x12_xml',
            type: 'string',
            isCollection: false
          },
        ]
    },
    {
      key: 'app/functions/edi_x12_945_map',
      name: 'app/functions/edi_x12_945_map',
      referenceName: 'edi_x12_945_map',
      appReferenceName: 'app',
      type: 9,
        inParams: [
          {
            required: false,
            id: 'integration_id',
            type: 'string',
            isCollection: false
          },
          {
            required: false,
            id: 'transaction_id',
            type: 'string',
            isCollection: false
          },
          {
            required: false,
            id: 'correlation_id',
            type: 'string',
            isCollection: false
          },
          {
            required: false,
            id: 'transaction_type',
            type: 'string',
            isCollection: false
          },
          {
            required: false,
            id: 'datex_order_info',
            type: 'string',
            isCollection: false
          },
        ]
    },
    {
      key: 'app/functions/edi_xml_submit_omicron',
      name: 'app/functions/edi_xml_submit_omicron',
      referenceName: 'edi_xml_submit_omicron',
      appReferenceName: 'app',
      type: 9,
        inParams: [
          {
            required: false,
            id: 'XMLContent',
            type: 'string',
            isCollection: false
          },
          {
            required: false,
            id: 'CorrelationId',
            type: 'string',
            isCollection: false
          },
          {
            required: false,
            id: 'TransactionId',
            type: 'string',
            isCollection: false
          },
          {
            required: false,
            id: 'IntegrationId',
            type: 'string',
            isCollection: false
          },
        ]
    },
    {
      key: 'app/functions/edi_datex_order_info_submit',
      name: 'app/functions/edi_datex_order_info_submit' + ' ('+ 'FootprintEdi' +')',
      referenceName: 'edi_datex_order_info_submit',
      appReferenceName: 'FootprintEdi',
      type: 9,
        inParams: [
          {
            required: false,
            id: 'integration_id',
            type: 'string',
            isCollection: false
          },
          {
            required: false,
            id: 'datex_order_info_xml',
            type: 'string',
            isCollection: false
          },
        ]
    },
    {
      key: 'app/functions/edi_delete_wavelength_transmissions',
      name: 'app/functions/edi_delete_wavelength_transmissions' + ' ('+ 'FootprintEdi' +')',
      referenceName: 'edi_delete_wavelength_transmissions',
      appReferenceName: 'FootprintEdi',
      type: 9,
        inParams: [
          {
            required: true,
            id: 'entity',
            type: 'string',
            isCollection: false
          },
          {
            required: true,
            id: 'id',
            type: 'number',
            isCollection: false
          },
          {
            required: false,
            id: 'transaction_id',
            type: 'string',
            isCollection: false
          },
          {
            required: true,
            id: 'transmission_type',
            type: 'string',
            isCollection: false
          },
          {
            required: true,
            id: 'transmission_direction',
            type: 'string',
            isCollection: false
          },
        ]
    },
    {
      key: 'app/functions/edi_submit_datex_order_info_xml',
      name: 'app/functions/edi_submit_datex_order_info_xml' + ' ('+ 'FootprintEdi' +')',
      referenceName: 'edi_submit_datex_order_info_xml',
      appReferenceName: 'FootprintEdi',
      type: 9,
        inParams: [
          {
            required: false,
            id: 'DatexOrderInfo',
            type: 'string',
            isCollection: false
          },
        ]
    },
    {
      key: 'app/functions/edi_manage_wavelength_transmissions',
      name: 'app/functions/edi_manage_wavelength_transmissions' + ' ('+ 'FootprintEdi' +')',
      referenceName: 'footprint_manage_wavelength_transmissions',
      appReferenceName: 'FootprintEdi',
      type: 9,
        inParams: [
          {
            required: true,
            id: 'entity',
            type: 'string',
            isCollection: false
          },
          {
            required: true,
            id: 'id',
            type: 'number',
            isCollection: false
          },
          {
            required: true,
            id: 'action',
            type: 'string',
            isCollection: false
          },
          {
            required: false,
            id: 'transaction_id',
            type: 'string',
            isCollection: false
          },
          {
            required: false,
            id: 'integration_id',
            type: 'string',
            isCollection: false
          },
          {
            required: false,
            id: 'transmission_type',
            type: 'string',
            isCollection: false
          },
          {
            required: false,
            id: 'transmission_direction',
            type: 'string',
            isCollection: false
          },
          {
            required: false,
            id: 'notes',
            type: 'string',
            isCollection: false
          },
          {
            required: false,
            id: 'transmission_id',
            type: 'number',
            isCollection: false
          },
          {
            required: false,
            id: 'type_id',
            type: 'number',
            isCollection: false
          },
          {
            required: false,
            id: 'integration_name',
            type: 'string',
            isCollection: false
          },
        ]
    },
    {
      key: 'app/datasources/ds_get_wavelength_shipment_transmissions',
      name: 'app/datasources/ds_get_wavelength_shipment_transmissions' + ' ('+ 'FootprintEdi' +')',
      referenceName: 'ds_get_wavelength_order_transmissions',
      appReferenceName: 'FootprintEdi',
      type: 6,
      methods: [
        {
          key: 'get',
          name: 'get',
          inParams: [
            {
              required: false,
              id: 'orderId',
              type: 'number',
              isCollection: false
            },
            {
              required: false,
              id: 'transactionId',
              type: 'string',
              isCollection: false
            },
          ]
        },
        {
          key: 'getList',
          name: 'getList',
          inParams: [
            {
              required: false,
              id: 'orderId',
              type: 'number',
              isCollection: false
            },
            {
              required: false,
              id: 'transactionId',
              type: 'string',
              isCollection: false
            },
            {
              required: false,
              id: '$top',
              type: 'number',
              isCollection: false
            },
            {
              required: false,
              id: '$skip',
              type: 'number',
              isCollection: false
            },
          ]
        },
        {
          key: 'getByKeys',
          name: 'getByKeys',
          inParams: [
            {
              required: false,
              id: 'orderId',
              type: 'number',
              isCollection: false
            },
            {
              required: false,
              id: 'transactionId',
              type: 'string',
              isCollection: false
            },
            {
              required: true,
              id: '$keys',
              type: 'number',
              isCollection: true
            },
          ]
        },
      ]
    },
  ];

  async configDisplayWithFn(value: any): Promise<string> {
    return this.configList.find(item => item.key === value)?.name;
  }

  async configOptionsFn(filterText: string): Promise<{ list: Array<{ key: any; name: string; disabled?: boolean; }>, totalCount?: number, top?: number }> {
    let list = this.configList.filter(item => item.type === this.typeValue);
    const totalCount = list.length;
    if (this.$utils.isDefinedTrimmed(filterText)) {
      list = list.filter(item => item.name.startsWith(filterText));
    }

    return { list, totalCount };
  }
  
  configValueChange(value) {
    this.configValue = value;
    this.config = this.configList.find(item => item.key === value);
    this.methodValueChange(null);
    this.dd_method.clearListData();
  }

  get hasMethods():boolean {
    return this.config && this.config?.methods;
  }
  
  method = null;
  methodValue = null;

  async methodDisplayWithFn(value: any): Promise<string> {
    return value;
  }

  async methodOptionsFn(filterText: string): Promise<{ list: Array<{ key: any; name: string; disabled?: boolean; }>, totalCount?: number, top?: number }> {
    let list = this.config.methods;
    const totalCount = list.length;
    if (this.$utils.isDefinedTrimmed(filterText)) {
      list = list.filter(item => item.name.startsWith(filterText));
    }

    return { list, totalCount };
  }
  
  methodValueChange(value) {
    this.methodValue = value;
    this.result = null;    
    if (this.hasMethods) {
      this.method = this.config.methods.find(item => item.key === value);
    } else {
      this.method = null;
    }
    this.onInParamChanged();
  }


  get inParams() {
    if (this.config) {
      if (this.config.methods) {
        if (this.method) {
          return this.method.inParams;
        }
      } else {
        return this.config.inParams;
      }
    }
    return null;
  }

  previewInParams = null;
  onInParamChanged() {
    this.previewInParams = {};
    if (this.inParams && this.inParams.length) {
      const inParams: { [key: string]: any } = {};
      this.inParams.forEach(ip => {
        inParams[ip.id] = this.evaluateValue(ip.value);
      });
      this.previewInParams = inParams;
    }
  }

  evaluateValue(value: string) {
    const val = this.$utils.isDefinedTrimmed(value) ? `(${value})` : value;
    const f = new Function(`{ return ${val} }`);
    return f();
  }

  get canExecute (): boolean {
    if (!this.config) {
      return false;
    }
    if (this.config.type === 6 && !this.methodValue) {
      return false;
    } 
    return true;
  }

  result: any;
  async run() {
    if (this.config.type === 6) {
      this.result = await this.$datasources[this.config.appReferenceName][this.config.referenceName][this.methodValue](this.previewInParams);
    } else if (this.config.type === 9) {
      this.result = await this.$flows[this.config.appReferenceName][this.config.referenceName](this.previewInParams);
    }
  }  
}
